import React, { useState } from "react";
import "./SpecialPrograms.css";
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import QuickLinks from "../sap-components/QuickLinks";
import Upload from "./special-programs/Upload";
import axios from 'axios';
import { useMsal } from "@azure/msal-react";
import { atci_lkm_sap_mail, saraswathi_mail } from "../utils/mailIds";

const SpecialPrograms = () => {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  let url = 'https://atci.lkm.eitacademy.accenture.com/ips-apis/sap/download';
  // let url = 'http://localhost:3001/sap/download';

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

  const allowedEnterpriseId = [
    "ankur.e.mishra",
    "varsha.a.tyagi",
    "poruri.rama.pavani",
    "s.saraswathi"
  ];

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const botClickFun = () => {
    document.getElementById('cai-webclient-builtin-button').click();
  };

  const handleOpenModal = () => {
    setShow(true);
  };

  const handleCloseModal = () => {
    setShow(false);
  }

  const handleModalOpen = () => {
    handleDownload();
  };

  const handleDownload = () => {
    axios({ method: 'get', url: `${url}`, responseType: 'blob', headers: { 'Authorization': localStorage.getItem("token") } })
      .then(response => {
        const url = URL.createObjectURL(response.data);
        window.open(url, '_blank');
      })
      .catch(err => console.log(err))
  }

  return (
    <>
      <div id="main_container" className="sap_main_container">
        <div>
          <img
            src={
              process.env.PUBLIC_URL +
              "/images/SAP/special_programs/specialPrograms-banner.png"
            }
            alt="SpecialProgram-Banner"
            className="img-responsive"
          />
        </div>
        <div className="programs-container">
          <div className="programs-cards">
            <div className="program-img-sap-btp" />
            <hr className="hr-tag" />
            <div className="program-content">
              <a onClick={handleModalOpen}>
                SAP BTP Learning Journey
                <img
                  className="program-icon"
                  src={
                    process.env.PUBLIC_URL +
                    "/images/SAP/special_programs/sapqleader-icon.png"
                  }
                />
              </a>
              {allowedEnterpriseId.includes(loggedInEnterpriseId) && <Upload />}
            </div>
          </div>
          <div className="programs-cards">
            <div className="program-img0" />
            <hr className="hr-tag" />
            <div className="program-content">
              <a
                href="https://atci.lkm.ind.accenture.com/iSpark/SAP-BTP"
                target="_blank"
              >
                iSpark Program
                <img
                  className="program-icon"
                  src={
                    process.env.PUBLIC_URL +
                    "/images/SAP/special_programs/sapqleader-icon.png"
                  }
                />
              </a>
            </div>
          </div>
          <div className="programs-cards">
            <div className="program-img1" />
            <hr className="hr-tag" />
            <div className="program-content">
              <a
                href="https://deepknowledge.accenture.com/home/sap-leader-series"
                target="_blank"
              >
                SAPQ for Leaders
                <img
                  className="program-icon"
                  src={
                    process.env.PUBLIC_URL +
                    "/images/SAP/special_programs/sapqleader-icon.png"
                  }
                />
              </a>
            </div>
          </div>
          <div className="programs-cards">
            <div className="program-img2" />
            <hr className="hr-tag" />
            <div className="program-content">
              <a
                href="https://atci.lkm.accenture.com/QuantumImpact/home"
                target="_blank"
              >
                Quantum Impact Program
                <img
                  className="program-icon"
                  src={
                    process.env.PUBLIC_URL +
                    "/images/SAP/special_programs/QIP-icon.png"
                  }
                />
              </a>
            </div>
          </div>
          <div className="programs-cards">
            <div className="program-img3" />
            <hr className="hr-tag" />
            <div className="program-content">
              <a href="https://atci.lkm.eitacademy.accenture.com/SAPAscend/home" target="_blank"
              //onClick={handleOpen}
              >
                SAP Ascend
                <img
                  className="program-icon"
                  src={
                    process.env.PUBLIC_URL +
                    "/images/SAP/special_programs/sap-ascend-icon.png"
                  }
                />
              </a>
              {/* <Modal
                hideBackdrop
                open={open}
                onClose={handleClose}
                aria-labelledby="child-modal-title"
                closeAfterTransition
                aria-describedby="child-modal-description"
              >
                <Box className="ascend_box">
                  <div>
                    <div className="ascend_heading">
                      <h3 className="paramodel">SAP Ascend </h3>
                      <span className="close_btn_model" onClick={handleClose}>
                        Close
                      </span>
                    </div>
                    <hr />
                    <div>
                    <div>
                        <p className="SAP_AscendInfo">
                          SAP is a major business group in Enterprise and Industry Technologies (E&IT) that helps our clients unlock
                          incremental business value and enable the highest
                          growth value for Accenture by combining technology and
                          industry excellence to create innovative solutions.
                          Our SAP practice is in high demand across many
                          industries.
                          </p>
                          <br />
                          <p>
                          To help us increase and strengthen our SAP presence
                          and provide our SAP practitioners with a market edge,
                          we had launched <strong>SAP Ascend</strong>, an SAP
                          Certification drive.
                          </p>
                        
                        <br />
                        <p>
                          For our SAP practitioners, this is a great chance to
                          increase their proficiency in various SAP areas. The
                          certifications in the drive cover the following areas:
                        </p>
                        <br />
                      </div>
                      <div className="acend_points">
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>Customer Experience (CX)</span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>Data</span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>Finance</span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>Information Lifecycle Management (ILM)</span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>Logistics & Supply Chain</span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>Open Text</span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>Basis/HANA/J2C</span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>
                            Governance, Risk, and Compliance (GRC) & Security
                          </span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>SAP Solution Manager</span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>SuccessFactors</span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>Tech Dev</span>
                        </div>
                      </div>
                      <div className="contact-us">
                      <p>
                        </p>
                      </div>
                    </div>
                  </div>
                </Box>
              </Modal> */}
            </div>
          </div>
          <div className="programs-cards">
            <div className="program-img4" />
            <hr className="hr-tag" />
            <div className="program-content">
              <a
                href="https://deepknowledge.accenture.com/home/prog-sac"
                target="_blank"
              >
                SAP Analytics Cloud (SAC) for Leaders
                <img
                  className="program-icon"
                  src={
                    process.env.PUBLIC_URL +
                    "/images/SAP/special_programs/sapqleader-icon.png"
                  }
                />
              </a>
            </div>
          </div>
          <div className="programs-cards">
            <div className="program-img5" />
            <hr className="hr-tag" />
            <div className="program-content">
              <a
                href="https://deepknowledge.accenture.com/home/prog-sap-fse"
                target="_blank"
              >
                SAP Full Stack Program
                <img
                  className="program-icon"
                  src={
                    process.env.PUBLIC_URL +
                    "/images/SAP/special_programs/QIP-icon.png"
                  }
                />
              </a>
            </div>
          </div>
          <div className="programs-cards">
            <div className="program-img6" />
            <hr className="hr-tag" />
            <div className="program-content">
              <a
                href="https://deepknowledge.accenture.com/home/sap-analytics"
                target="_blank"
              >
                SAP Analytics ++ Ecosphere
                <img
                  className="program-icon"
                  src={
                    process.env.PUBLIC_URL +
                    "/images/SAP/special_programs/sapqleader-icon.png"
                  }
                />
              </a>
            </div>
          </div>
          <div className="programs-cards">
            <div className="program-img7" />
            <hr className="hr-tag" />
            <div className="program-content">
              <a
                href="https://deepknowledge.accenture.com/home/prog-sap-btp"
                target="_blank"
              >
                SAP Business Technology Platform (BTP) Role-Based Learning Journey
                <img
                  className="program-icon"
                  src={
                    process.env.PUBLIC_URL +
                    "/images/SAP/special_programs/sapqleader-icon.png"
                  }
                />
              </a>
            </div>
          </div>
        </div>

        <div className="socialMediaWrap">
          <button className="iconBtn icon6">
            <a href="https://atci.lkm.eitacademy.accenture.com/SAPAcademy/sap-calendar/" target="_blank" rel="noreferrer">
              <img src={process.env.PUBLIC_URL + '/images/SAP/sap_calendar.png'} alt="oracle-icon" />
              <span>SAP Calendar</span>
            </a>
          </button>
          <button className="iconBtn icon5">
            <a href="https://atci.lkm.accenture.com/LKM-eCatalog/SAP-Flipbook" target="_blank" rel="noreferrer">
              <img src={process.env.PUBLIC_URL + '/images/SAP/catalogue_icon.png'} alt="ecatalogs-icon" />
              <span>SAP eCatalog</span>
            </a>
          </button>
          <button className="iconBtn icon4" onClick={botClickFun}>
            <img src={process.env.PUBLIC_URL + '/images/SocialLearning/noun-chatbot-4562760.svg'} alt="oracle-icon" />
            <span>SAP Bot</span>
          </button>
          <button onClick={handleOpenModal} className="iconBtn icon1">
            <img src={process.env.PUBLIC_URL + '/images/SocialLearning/present.svg'} alt="oracle-icon" />
            <span>Request for Training</span>
          </button>
          <Modal
            open={show}
            onClose={handleCloseModal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
          >
            <div className="model-container">
              <span className="close_btn_model_reqtraining" onClick={handleCloseModal}>
                X
              </span>
              <h4>Request For Training</h4>
              <div className="model_heading_reqtraining">
                <p className="model_name_reqtraining">
                  <a
                    href="https://lkmportal.atci.accenture.com/LMS/Need/RaiseTrainingRequest"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Link to raise training request
                  </a>
                </p>
                <div className="modal_content_reqtraining">
                  For further queries please get in touch with <br />
                </div>
                <p className="model_contact_reqtraining">
                  <a href={`mailto:${saraswathi_mail}`} target="_blank" rel="noreferrer">
                    Swaminathan, Saraswathi.
                  </a>
                </p>
              </div>
            </div>
          </Modal>
          <button className="iconBtn icon2">
            <a
              href="https://web.yammer.com/main/org/accenture.com/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiI1NzgyMjY5OTUyMCJ9"
              target="_blank"
              rel="noreferrer"
            >
              <img src={process.env.PUBLIC_URL + '/images/SocialLearning/Yammer1.png'} alt="oracle-icon" />
              <span>Connect with Community</span>
            </a>
          </button>
          <button className="iconBtn icon3">
            <a href={`mailto:${atci_lkm_sap_mail}`} target="_blank" rel="noreferrer">
              <img src={process.env.PUBLIC_URL + '/images/SocialLearning/mail.svg'} alt="oracle-icon" />
              <span>Contact Us</span>
            </a>
          </button>
        </div>
        <QuickLinks />
      </div>
    </>
  );
};

export default SpecialPrograms;
